import "./modules/change-view.js";
import "./modules/single-product-carousel.js";
import "./modules/menu.js";
import "./modules/parallax-gsap.js";
import "./modules/specjalisci-carousel.js";
import "./modules/image-carousel.js";
import "./modules/product-page.js";
import "./modules/accordion.js";
import "./modules/fancybox.js";
import "./modules/add-to-cart-ajax.js";

function applyMaxWidthToMedia() {
  const containers = document.querySelectorAll(
    ".right-image-max-width-none, .left-image-max-width-none",
  );

  if (window.innerWidth <= 991) {
    containers.forEach((container) => {
      const media = container.querySelector("img, video");
      if (media) {
        media.style.maxWidth = "";
      }
    });
    return;
  }

  const maxWidth = window.innerWidth / 2 + "px";

  containers.forEach((container) => {
    const media = container.querySelector("img, video");
    if (media) {
      media.style.maxWidth = maxWidth;
    }
  });
}

applyMaxWidthToMedia();
window.addEventListener("resize", applyMaxWidthToMedia);
